module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/71.f975a5cc.png";